import React, { useState, useEffect } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import DisplayExport from "../../../components/Exports/DisplayExport";
import TableOfViewRegisters from "./components/TableOfViewRegisters";
import deepFlattenToObject from "../../../../functions/deepFlattenToObject";
import SearchSetRegisters from "../../../components/Search/SearchSetRegisters";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Get_Registers_With_Options } from "../../../api/Get_Registers_With_Options";
import { Request_Get_Registers_Fuzzy_Search } from "../../Registers/api/Request_Get_Registers_Fuzzy_Search";
import { Get_Registers_For_Medical_Overview } from "../api/Get_Registers_For_Medical_Overview";

function CurtAI_Get_Medical_Overview() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------

  // Assuming you have a state to store the fetched data
  const [Registers, setRegisters] = useState([]);

  useEffect(() => {
    Get_Registers_For_Medical_Overview({}, setRegisters, logout);
  }, []);

  // -----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>

        <TableOfViewRegisters
          style={{ flex: "0 1 auto" }}
          Registers={Registers}
        />
      </div>
    </div>
  );
}

export default CurtAI_Get_Medical_Overview;
